export const fontSizeBase = '0.95rem';
export const fontSizeLg = fontSizeBase * 1.25;
export const fontSizeSm = fontSizeBase * .875;
export const fontSizeXs = fontSizeBase;
export const fontSizeXl = fontSizeBase * 1.35;

export const themeSpacer = '1rem';
export const layoutSpacer = themeSpacer * 2;
